<div class="addressbar">
  <span class="addresstext">Komunalno / Obrada dugovanja / Pokretanje</span>
</div>
<div class="containerpadding">
  <div class="row">
    <div class="col-12">
      <mat-card-title>
        Odabir korisnika za obradu dugovanja
      </mat-card-title>
      <hr />
    </div>
    <div  class="col-12">
      <korisnik-select (podaci)="OdabirKorisnika($event)"></korisnik-select>
      <korisnik-info *ngIf="korisnik" [korisnik]="korisnik"></korisnik-info>
    </div>
  </div>





  <div *ngIf="korisnik" class="d-flex justify-content-center row col-12 mt-1">
    <mat-card appearance="outlined" class="col-12">
      <mat-card-header><mat-card-title>Kartica korisnika - odaberite samo račune</mat-card-title></mat-card-header>
      <mat-card-content>        
        
        <div class="d-flex justify-content-between">
          <span>Broj odabranih: {{brojodabranih}}</span><button mat-button (click)="OznaciSve()"><mat-icon *ngIf="!oznaci" aria-hidden="false" aria-label="Odustani"><span class="material-icons">check_box</span></mat-icon><mat-icon *ngIf="oznaci" aria-hidden="false" aria-label="Odustani"><span class="material-icons">check_box_outline_blank</span></mat-icon>Označi</button>
        </div>
        <table *ngIf="lista" mat-table [dataSource]="lista"  matSort style="width:100%">


          <ng-container matColumnDef="datum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum </th>
            <td mat-cell *matCellDef="let element">{{element.datum  | date: 'dd.MM.yyyy'}} </td>
            <td mat-footer-cell *matFooterCellDef> Ukupno </td>
          </ng-container>

          <ng-container matColumnDef="isprava">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Isprava </th>
            <td mat-cell *matCellDef="let element">{{element.isprava}} {{element.redniBroj}} {{element.pozicija}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          

          <ng-container matColumnDef="opis">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Opis </th>
            <td mat-cell *matCellDef="let element">{{element.opis}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="racun">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Račun </th>
            <td mat-cell *matCellDef="let element">{{element.racun}}</td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="datumRacuna">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum računa</th>
            <td mat-cell *matCellDef="let element">{{element.datumRacuna  | date: 'dd.MM.yyyy'}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <ng-container matColumnDef="valutaRacuna">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Valuta računa</th>
            <td mat-cell *matCellDef="let element">{{element.valutaRacuna  | date: 'dd.MM.yyyy'}} </td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>


          <ng-container matColumnDef="duguje">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Duguje </th>
            <td mat-cell *matCellDef="let element" class="text-right">{{element.duguje | number: '1.2-2':'hr'}} </td>
            <td mat-footer-cell *matFooterCellDef class="text-right"> {{ukupnoduguje | number: '1.2-2':'hr'}} </td>
          </ng-container>

          <ng-container matColumnDef="potrazuje">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Potražuje </th>
            <td mat-cell *matCellDef="let element" class="text-right">{{element.potrazuje | number: '1.2-2':'hr'}} </td>
            <td mat-footer-cell *matFooterCellDef class="text-right"> {{ukupnopotrazuje | number: '1.2-2':'hr'}} </td>
          </ng-container>



          <ng-container matColumnDef="pokrenipostupak">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Pokreni postupak </th>
            <td mat-cell *matCellDef="let element" style="width:10%" class="text-center"><mat-checkbox [(ngModel)]="element.pokrenipostupak" (change)="prebroj()" name="pokrenipostupak"></mat-checkbox></td>
            <td mat-footer-cell *matFooterCellDef></td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row;columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
        
      </mat-card-content>
    </mat-card>
  </div>
  <hr />
  <div *ngIf="lista" class="col-12">
    <mat-card appearance="outlined">
      <mat-card-title>
        Pokretanje postupka za korisnike
      </mat-card-title>
      <mat-card-content>
        <mat-form-field *ngIf="listadokumenata" appearance="fill" class="col-lg-6 col-12">
          <mat-label>Dokument (status)</mat-label>
          <mat-select ngDefaultControl name="dokument" [(ngModel)]="startdata.dokumentId">
            <mat-option *ngFor="let dokument of listadokumenata" [value]="dokument.pravniDokumentVrstaId">
              {{dokument.sifra}} {{dokument.naziv}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-lg-4 col-12">
          <mat-label>Na dan</mat-label>
          <input matInput type="date" [ngModel]="startdata.nadan | date:'yyyy-MM-dd'" (ngModelChange)="startdata.nadan=$event" placeholder="Na dan" name="date">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-lg-4 col-12">
          <mat-label>Rok za plaćanje</mat-label>
          <input matInput [(ngModel)]="startdata.rokdana" placeholder="Rok za plaćanje" name="dana" type="number">
        </mat-form-field>
        <p>
          <button mat-button (click)="openDialog()" class="ok-color"><mat-icon aria-hidden="false" aria-label="Pokreni postupak">done</mat-icon> Pokreni postupak</button>
          <button mat-button (click)="pocetniuvjeti()" class="cancel-color"><mat-icon aria-hidden="false" aria-label="Odustani">clear</mat-icon>Odustani</button><br />
        </p>
        <p *ngIf="loading">
          Pokrećem postupak...
          <img class="pl-2" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        </p>
        <p *ngIf="rezultat">
          {{rezultat}}
        </p>
      </mat-card-content>
    </mat-card>
  </div>
</div>
